<template lang="pug">
.banner-link(:class="[getAdditionalClass, user]")
  h2.banner-link__title(v-if="title", v-html="title")
  p.banner-link__text(v-if="text") {{ text }}

  button.controller-play.banner-link__play-button(v-if="hasVideo", @click="showVideo(video)")
    span.controller-play__icon
  a.button.button-medium-x20.banner-link__button(v-if="hasCTA", :href="link") {{ button }}
  a.banner-link__link(v-if="hasLink", :href="link")

  img.banner-link__image(v-if="image", :src="getImageSrc", :alt="title")
  iframe.banner-link__video(v-else-if="hasVideo", :src="getVideoSrc", frameborder="0", allowfullscreen="allowfullscreen", allow="autoplay", width="907", height="510")

</template>

<script>
export default {
  name: "BannerLink",
  props: {
    link: {
      type: String,
      default: null,
    },
    button: {
      type: String,
      default: null,
    },
    video: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    user: {
      type: String,
      required: true,
    },
  },

  computed: {
    hasVideo() {
      return !!this.video;
    },
    hasCTA() {
      return !!this.button && !!this.link;
    },
    hasLink() {
      return this.user !== "not_authed" && !this.video && !this.button && !!this.link;
    },
    getAdditionalClass() {
      return !!this.button ? "banner-link--button" : "";
    },

    getImageSrc() {
      if (this.image.includes("https://")) {
        return this.image;
      }

      try {
        return require(`@/assets/images/${this.image}_${this.user}.jpg`);
      } catch (e) {
        return require(`@/assets/images/${this.image}.jpg`);
      }
    },
    getVideoSrc() {
      if (!this.hasVideo) return false;

      // return `https://www.youtube.com/embed/${this.video}?playlist=${this.video}&amp;autoplay=1&amp;rel=0&amp;showinfo=0&amp;mute=1&amp;loop=1&amp;controls=0`;
      let video_link_parts = this.video.split("_");
      return `https://vkvideo.ru/video_ext.php?oid=${video_link_parts[0]}&id=${video_link_parts[1]}&hd=2`;
    },
  },

  methods: {
    showVideo(video) {
      this.$emit("showVideo", video);
    },
  },
};
</script>
